<template>
   <div class="container text-zinc-700">
                <div class="grid grid-cols-1 pb-8 text-center">
                    <SectionTitleComponent :title="'Team'" />
                </div>

                <div class="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 mt-8 gap-0 md:p-0 p-8">
                    <div v-for="item in teamStore.team" :key="item" class="group relative overflow-hidden transition hover:cursor-pointer p-3">
                        <div class="absolute bottom-1 p-4 rounded-md text-transparent group-hover:shadow group-hover:text-zinc-700 left-3 right-3 w-auto">
                            <div class="-translate-y-full group-hover:translate-y-0 transition-all duration-500 ease-in-out">
                                <p class="text-center text-md font-bold italic mb-2 underline decoration-amber-400">{{item.quote}}</p>
                                <p v-for="spec of item.specs" :key="spec">- {{ spec }}</p>
                                <p class="group-hover:text-amber-400">{{ item.email }}</p>
                            </div>
                        </div>
            
                        <div class="relative overflow-hidden">
                            <img :src="item.image" class="group-hover:scale-125 duration-1000" alt="">
                            <div class="absolute inset-0 inset-bottom-20 bg-slate-900/30 hover:bg-slate-900/15 transition-all duration-500"></div>

                            <div class="absolute bottom-0 p-4">
                                <span class="text-lg font-semibold text-amber-300 transition-all duration-500">{{item.firstname}} {{ item.lastname }}</span>
                            </div>
                        </div>                            

                        <div class="hidden group-hover:block text-transparent mt-5">
                            <div>
                                <p class="text-center text-lg italic mb-2">{{item.quote}}</p>
                                <p v-for="spec of item.specs" :key="spec">- {{ spec }}</p>
                                <p>{{ item.email }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="grid md:grid-cols-1 grid-cols-1 mt-8">
                    <div class="md:col-span-12 text-center">
                        <router-link to="/vacatures"
                            class="btn btn-link text-slate-400 hover:text-slate-700 after:bg-amber-300 duration-500 ease-in-out">
                            Bekijk vacatures <i class="uil uil-arrow-right align-middle"></i></router-link>
                    </div>
                </div> -->
            </div>
</template>

<script setup>

import SectionTitleComponent from '@/components/SectionTitleComponent.vue';
import { useTeamStore } from '@/stores/team';

let teamStore = useTeamStore();

</script>

<style lang="scss" scoped></style>